import { render, staticRenderFns } from "./DeveloperSetting.vue?vue&type=template&id=2500cab5&"
import script from "./DeveloperSetting.vue?vue&type=script&lang=js&"
export * from "./DeveloperSetting.vue?vue&type=script&lang=js&"
import style1 from "./DeveloperSetting.vue?vue&type=style&index=1&id=2500cab5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports